import ApiService from "../ApiService";

const branchService = {
    allBranches() {
        return ApiService.get(`/branch`);
    },
    allBranchesPolicy() {
        return ApiService.get(`/policy-branch`);
    },

    searchBranche(page, PerPage, searchString) {
        return ApiService.get(
            `/branch/search?page=${page}&perPage=${PerPage}&searchString=${searchString}`
        );
    },
    searchBranchePolicy(page, PerPage, searchString) {
        return ApiService.get(
            `/policy-branch/search?page=${page}&perPage=${PerPage}&searchString=${searchString}`
        );
    },

    getBranchByCity(page, PerPage, searchString) {
        return ApiService.get(
            `/branch/with-cities/?page=${page}&perPage=${PerPage}&searchString=${searchString}`
        );
    },
    getBranchByCityPolicy(page, PerPage, searchString) {
        return ApiService.get(
            `/policy-branch/with-cities/?page=${page}&perPage=${PerPage}&searchString=${searchString}`
        );
    },
    getBranchesByprovider(providerId) {
        providerId = providerId || 0;
        return ApiService.get(`/branch/provider/${providerId}`);
    },

    createBranch(formData) {
        return ApiService.post("/branch", formData);
    },
    createBranchPolicy(formData) {
        return ApiService.post("/policy-branch", formData);
    },
    getByProviders(data) {
        return ApiService.post("/branch/byProviders", data);
    },
    getByProvidersPolicy(data) {
        return ApiService.post("/policy-branch/byProviders", data);
    },

    createShippingFee(formData) {
        return ApiService.post("/provider-schedule-range", formData);
    },
    createShippingFeePolicy(formData) {
        return ApiService.post("/policy-schedule-range", formData);
    },
    updateShippingFee(formData) {
        return ApiService.post("/provider-schedule-range/update", formData);
    },
    updateShippingFeePolicy(formData) {
        return ApiService.post("/policy-schedule-range/update", formData);
    },
    deleteBranch(formData) {
        return ApiService.post(`/branch/remove/`, formData);
    },
    deleteBranchPolicy(formData) {
        return ApiService.post(`/policy-branch/remove/`, formData);
    },
    updateBranch(id, formData) {
        return ApiService.post(`/branch/update?id=${id}`, formData);
    },
    updateBranchPolicy(id, formData) {
        return ApiService.post(`/policy-branch/update?id=${id}`, formData);
    },
};

export default branchService;